import React from 'react';
import { HeartIcon } from 'lucide-react';
export function EmpathySection() {
  return <section className="py-14 px-5" data-id="element-113">
      <div className="max-w-lg mx-auto" data-id="element-114">
        <div className="rounded-2xl p-8 md:p-10" style={{
        backgroundColor: '#FFF9F0'
      }} data-id="element-115">
          {/* Heart + Paw Icon */}
          <div className="flex justify-center mb-6" data-id="element-116">
            <div className="relative w-14 h-14 flex items-center justify-center" data-id="element-117">
              <HeartIcon className="w-10 h-10 text-rose-400 fill-rose-400/20" data-id="element-118" />
              <span className="absolute bottom-0 right-0 text-lg" data-id="element-119">🐾</span>
            </div>
          </div>

          <h2 className="font-serif text-2xl md:text-3xl text-charcoal text-center leading-snug mb-6 italic" data-id="element-120">
            🐾 Usted no tiene un perro malo, tiene un perro que no sabe cómo
            gestionar su estrés.
          </h2>

          <div className="space-y-4 text-charcoal/80 text-[15px] leading-relaxed text-center" data-id="element-121">
            <p data-id="element-122">
              Sabemos que sentir los tirones constantes genera frustración, pero
              su perro no lo hace por desobediencia. Lo hace porque su sistema
              nervioso está colapsado.
            </p>
            <p data-id="element-123">DOG-CALM™ no es solo adiestramiento; es un acto de cariño.</p>
            <p className="font-medium text-charcoal/90" data-id="element-124">
              Pero sabemos que la paz no termina en la calle. Por eso, hemos
              diseñado la herramienta definitiva para proteger vuestro hogar
              cuando tú tienes que salir por la puerta.
            </p>
          </div>
        </div>
      </div>
    </section>;
}